<template>
    <div class="gallery-wrapper">
        <div class="gallery" :data-item-id="itemId" v-if="imageUrls.length > 0" ref="gallery">
            <template v-if="imageUrls.length > 1 && enableCarousel">
            <lazy-img 
                :ref="{ 'itemLazyImage': !disableLazyLoad }"
                :image-url="imageOrItemImage"
                :alt="getAltText(imageUrls[0])"
                :image-alt="getImageAltText(imageUrls[0])"
                :id="getId(imageUrls[0])"
                :title="getTitleText(imageUrls[0])"
                :width="getImageWidth(imageUrls[0])"
                :height="getImageHeight(imageUrls[0])"
                class="mainImg"
                picture-class="mainImg" />

                <lazy-img 
                :ref="{ 'itemLazyImage': !disableLazyLoad }"
                :image-url="imageUrls[1].url"
                :alt="getAltText(imageUrls[1])"
                :image-alt="getImageAltText(imageUrls[1])"
                :id="getId(imageUrls[1])"
                :title="getTitleText(imageUrls[1])"
                :width="getImageWidth(imageUrls[1])"
                :height="getImageHeight(imageUrls[1])"
                class="secondImg"
                picture-class="secondImg" />
            </template>
            <template v-else>
                <lazy-img 
                    :ref="{ 'itemLazyImage': !disableLazyLoad }"
                    :image-url="imageOrItemImage"
                    :alt="getAltText(imageUrls[0])"
                    :title="getTitleText(imageUrls[0])"
                    :width="getImageWidth(imageUrls[0])"
                    :height="getImageHeight(imageUrls[0])"
                    class="mainImg"
                    picture-class="mainImg" />
            </template>
        </div>
        <span :class="{'d-none': !dotsVisible}" class="dots" ref="dots"></span>
    </div>
</template>

<script>

export default {

    name: "category-image-carousel",

    props: {
        imageUrlsData:
        {
            type: Array
        },
        itemUrl:
        {
            type: String
        },
        itemId:
        {
            type: Number,
            default: 0
        },
        alt:
        {
            type: String
        },
        title:
        {
            type: String
        },
        showNav:
        {
            type: Boolean,
            default: App.config.item.categoryShowNav
        },
        disableLazyLoad: {
            type: Boolean,
            default: false
        },
        disableSecondImg: {
            type: Boolean,
            default: false
        },
        disableCarouselOnMobile:
        {
            type: Boolean,
            default: false
        },
        enableCarousel:
        {
            type: Boolean
        },
        template:
        {
            type: String
        }
    },

    data() {
        return {
            $_enableCarousel: false,
            dotsVisible: false
        };
    },

    computed:
    {
        imageUrls() {
            return this.imageUrlsData;
        },
        imageOrItemImage()
        {
            return this.imageUrls.length ? this.imageUrls[0].url : this.itemImage;
        }
    },

    mounted() {
        const isMobile = window.matchMedia("(max-width: 768px)").matches;
        this.$nextTick(() => {
            this.initDots();
        });
    },

    methods:
    {
        initializeCarousel() {
           return;
        },

        initDots()
        {
            this.$refs.gallery.addEventListener("scroll", () =>
            {
                this.currentItem = Math.round(this.$refs.gallery.scrollLeft / this.$refs.gallery.clientWidth);
                const dots = this.$refs.dots.children;
                for(let i = 0; i < dots.length; i++)
                {
                    dots[i].classList.remove("active");
                }
                dots[this.currentItem].classList.add("active");
            });
            
            // empty all existing dots first
            const children = this.$refs.gallery.children;
            const numChildren = children.length;
            if(numChildren > 1)
            {
                this.dotsVisible = true; // show dots only if there are more than 1 images
                this.$refs.dots.innerHTML = "";
                for(let i = 0; i < numChildren; i++)
                {
                    const dot = document.createElement("span");
                    dot.classList.add("dot");

                    if(i == 0) dot.classList.add("active");

                    // if i is the current item, add the active class
                    // make it change, when the scroll changes
                    this.$refs.dots.appendChild(dot);
                }
            }
        },

        getAltText(image)
        {
            const alt = image && image.alternate ? image.alternate : this.alt;

            return alt;
        },
        getImageAltText(image)
        {
            const alt = image && image.alternate ? image.alternate : "";
            return alt;
        },

        getTitleText(image)
        {
            const title = image && image.name ? image.name : this.title;

            return title;
        },

        getId(image)
        {
            const id = image && image.id ? image.id : 0;
            return id;
        },

        getImageWidth(image)
        {
            return image && image.width ? image.width : undefined;
        },

        getImageHeight(image)
        {
            return image && image.height ? image.height : undefined;
        }
    }
}
</script>